/**
 * NOT USED
 */
export class DoctorVisitSurvey {
    public questions: Question[];
  constructor() {
  }

}

export class Question {
  public questionText: string;
  public answer: string;

}
